<template>
  <!-- <v-app>
    <v-content> -->
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Acceso Usuario</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="person"
                name="login"
                label="Email"
                type="text"
                v-model="email"
              ></v-text-field>
              <v-text-field
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login">Login</v-btn>
          </v-card-actions>
        </v-card>
        <v-alert v-model="alert" dismissible type="error">
          {{ errorMessage }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </v-content>
  </v-app> -->
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    drawer: null,
    email: "",
    password: "",
    alert: false,
    errorMessage: ""
  }),
  props: {
    // source: String
  },
  methods: {
    login() {
      if (this.email.length < 5 || this.password.length < 5) {
        this.errorMessage =
          "Debe indicar un email y un password válido. Mínimo 6 caracteres.";
        this.alert = true;
        return false;
      }
      this.$auth.signInWithEmailAndPassword(this.email, this.password).then(
        () => {
          this.$router.replace("/user");
        },
        error => {
          // eslint-disable-next-line
                console.log(error)
          let msg = error.message;
          if (msg.indexOf("password") > -1) {
            msg =
              "El password introducido no es correcto. Por favor asegúrese de introducir el password correcto.";
          }
          if (msg.indexOf("user") > -1) {
            msg =
              "El email introducido no se encuentra registrado en nuestra base de datos. Por favor verifique su email o contacte con nosostros.";
          }
          alert(msg);
        }
      );
      /* this.$auth.signInWithEmailAndPassword(this.email, this.password)
                // .then(function(user) {
                    // this.user = user
                // }.bind(this))
                .catch(error => {
                    // Handle Errors here.
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    let code = errorCode
                    let mensaje = errorMessage
                    if (errorCode === 'auth/wrong-password') {
                        code = 'Password incorrecto'
                        mensaje = 'El password que ha introducido no es válido'
                    }
                    if (errorCode === 'auth/user-not-found') {
                        code = 'Usuario no encontrado'
                        mensaje = 'El usuario introducido no existe en nuestra base de datos'
                    }
                    this.errorMessage = `Error: ${code}. ${mensaje}`
                    this.alert = true
                    // Error: auth/wrong-password, The password is invalid or the user does not have a password
                    // Error: auth/user-not-found, There is no user record corresponding to this identifier. The user may have been deleted.
                }) */
    }
  }
};
</script>
